import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, Subject, takeUntil } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Account } from '../models/account.model';
import { Asset } from "../models/asset.model";
import { Response } from '../models';

@Injectable({ providedIn: 'root' })
export class AccountService {

  private accounts: Array<Account>
  private assets: Array<Asset>;

  constructor(private http: HttpClient) { }

  getUserAccounts(): Promise<Response<Array<Account>>> {
    return firstValueFrom(this.http.get<Response<Array<Account>>>(`${environment.apiEndpoint}/accounts/user-accounts`));
  }

  getUserAccountAssets(accountIds: number[], cancellation: Subject<void>): Promise<Response<Array<Asset>>> {
    return firstValueFrom(this.http.post<Response<Array<Asset>>>(`${environment.apiEndpoint}/accounts/user-accounts-assets`, { accountIds }).pipe(takeUntil(cancellation)));
  }

  setAccounts(accounts: Array<Account>) {
    this.accounts = accounts;
  }

  setAssets(assets: Array<Asset>) {
    this.assets = assets;
  }

  getAccounts(): Array<Account> {
    return this.accounts;
  }

  getAssets(): Array<Asset> {
    return this.assets;
  }
}
